import { useQuery } from '@tanstack/react-query';

import TimeRecorderService from '../../../../../../services/TimeRecorderService';

type Props = {
  userId: string;
  companyId: string;
};

function useUserTimeRecorderOvertimeInCounterConfiguration({
  userId,
  companyId,
}: Props) {
  const { data, refetch, isLoading } = useQuery({
    queryKey: [
      'TimeRecorderService.getUserOvertimeInCounterConfiguration',
      userId,
      companyId,
    ],
    queryFn: () =>
      TimeRecorderService.getUserOvertimeInCounterConfiguration(
        userId,
        companyId
      ),
  });

  return { configuration: data, refetch, isLoading };
}

export { useUserTimeRecorderOvertimeInCounterConfiguration };
